baseApp.service('ZoneService', function(){
    var zoneFactory ={};
    var zones ;

    function doCallback(callback){
        if(callback){
            callback(zones);
        }
    }

    /**
     * returns the pop license which has the license name and priority
     * by applying the callback on the result
     * @param callback
     */
    zoneFactory.getPopLicense = function(callback){
        if(!zones){
            store.fetch({
                path: "/getPopLicense",
                success: function(data) {
                    zones = [];
                    data.forEach(function (currZone) {
                        zones.push(currZone);
                    });
                    doCallback(callback);
                }
            });
        }
        else{
            doCallback(callback);
        }
    };


    /**
     * by using the getPopLicense method we extract just the regions from it
     * and applying the callback on it
     * @param callback
     */
    zoneFactory.getRegions = function (callback) {
        zoneFactory.getPopLicense(function (zones) {
            var regions = [];

            zones.forEach(function (currZone) {
                regions.push(currZone.Name);
            });

            if(callback)
                callback(regions);

        })
    };


    return zoneFactory;
});
